const state = {
  // 控制是否显示loading
  spinning: 0,
  tip: '加载中...'
}

const mutations = {
  showLoading (state, status) {
    state.spinning = status
  },
  add (state) {
    state.spinning += 1
  },
  sub (state) {
    state.spinning -= 1
  },
  clearSpinning (state) {
    state.spinning = 0
  },
  setTip (state, tip) {
    state.tip = tip
  },
}


export default {
  state, mutations, namespaced: true
}